const translations = {
  title: "Gold Passbook Ledger",
  subtitle: "Append-only log of all gold movements across vault, karigar, customer, and scrap.",
  // Entry types
  type_opening_vault: "Opening Vault",
  type_customer_gold_received: "Customer Gold Received",
  type_old_gold_received: "Gold Received from Customer",
  type_issue_to_karigar: "Issue to Karigar",
  type_receive_from_karigar: "Receive from Karigar",
  type_scrap_returned: "Scrap Returned",
  type_dust_returned: "Dust / Sweepings Returned",
  type_wastage: "Wastage",
  type_overloss: "Overloss",
  type_finished_item_created: "Finished Item Created",
  type_sale: "Sale",
  type_customer_gold_credit_applied: "Customer Gold Credit Applied",
  type_worker_gold_advance: "Worker Gold Advance",
  type_worker_wastage_gold_return: "Worker Wastage Return",
  type_adjustment: "Adjustment",
  type_reversal: "Reversal",
  type_gold_overdraft_issue: "Gold Overdraft Issue",
  type_melt_scrap_input: "Melt — Scrap Input",
  type_melt_dust_input: "Melt — Dust Input",
  type_melt_recovery_received: "Melt — Recovery Received",
  type_melt_loss: "Melt — Loss",
  // Buckets
  bucket_vault: "Vault",
  bucket_karigar: "Karigar",
  bucket_finished: "Finished",
  bucket_customer: "Customer",
  bucket_scrap: "Scrap",
  // Balance sheet
  balanceSheet: "Balance Sheet",
  totalUnderManagement: "Total Gold Under Management",
  totalPhysical: "Total Physical",
  discrepancy: "Discrepancy",
  balanced: "Balanced",
  entryCount: "Total Entries",
  // Fields
  entryDate: "Date",
  entryType: "Movement Type",
  netFineMg: "Net Fine (mg)",
  grossMg: "Gross (mg)",
  purity: "Purity",
  reference: "Reference",
  notes: "Notes",
  bucketDeltas: "Bucket Changes",
  // Actions
  addOpening: "Set Opening Vault",
  reverseEntry: "Reverse Entry",
  exportLedger: "Export Ledger",
  // Filters
  filterByType: "Filter by type",
  filterByBucket: "Filter by bucket",
  dateRange: "Date Range",
  // Columns
  col_date: "Date",
  col_type: "Type",
  col_net: "Net Fine (mg)",
  col_vault: "Vault",
  col_karigar: "Karigar",
  col_finished: "Finished",
  col_customer: "Customer",
  col_scrap: "Scrap",
  col_ref: "Reference",
  // Empty states
  noEntries: "No ledger entries yet.",
  setOpeningFirst: "Set the opening vault balance to begin.",
};

export default translations;
